<template>
	<form method="post" accept-charset="utf-8" v-html="html">
	</form>
</template>

<script>
	export default {
		props: ['user', 'isAuth', 'html'],
		data () {
			return {
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Form.vue